import { ComponentRef } from '@wix/editor-platform-sdk-types';
import { HostType } from '../types';
import { PlatformPrivateServices } from '../PlatformPrivateServices';
import { ApiConfig, Public, Private } from '../limitPrivateAPI';

export abstract class PrivateAPINamespace {
  public static readonly namespace: string;

  @ApiConfig(Private)
  protected ps: PlatformPrivateServices;

  @ApiConfig(Private)
  protected appDefinitionId: string | undefined;

  constructor(
    protected hostType: HostType,
    ps: PlatformPrivateServices,
    appDefinitionId?: string,
  ) {
    this.hostType = hostType;
    this.ps = ps;
    this.appDefinitionId = appDefinitionId;
  }

  protected getUnscopedCompRef(compRef: ComponentRef): ComponentRef {
    if (this.ps.ds.components.scopes.extractScopeFromPointer(compRef)) {
      return this.ps.ds.components.scopes.getTemplateCompPointer(compRef);
    }
    return compRef;
  }

  @ApiConfig(Private)
  withAppContext(appDefinitionId: string | undefined): this {
    if (this.appDefinitionId === appDefinitionId) {
      return this;
    }

    const NamespaceClass = this.constructor as new (
      _hostType: HostType,
      _ps: PlatformPrivateServices,
      _appDefinitionId?: string,
    ) => this;
    return new NamespaceClass(this.hostType, this.ps, appDefinitionId);
  }

  @ApiConfig(Public)
  waitForChangesApplied() {
    return new Promise<void>((resolve) =>
      this.ps.ds.waitForChangesApplied(resolve),
    );
  }
}
